import React from 'react';
import { Header } from '../../../components/Layout/Header';
import { Content } from '../../../components/Layout/Content';
import { L } from '../../../lib/i18n';
import styled from '@emotion/styled';
import { CalendarDetailEditor } from './CalendarDetailEditor';
import { RouteComponentProps } from 'react-router';

interface Props {
    id?: string;
}

const Container = styled.div({});

export function CalendarDetailPage(props: RouteComponentProps<{ id: string }>) {
    const id = props.match.params.id;
    return (
        <>
            <Header title={L('calendar')} to={'./'} text={`<-` + L('back_to_calendar')} />
            <Content>
                <div>
                    <Container>{id === 'new' ? <CalendarDetailEditor /> : <CalendarDetailEditor id={id} />}</Container>
                </div>
            </Content>
        </>
    );
}
